import { sanitizeHtml } from '@/utils/safeHtml';

/**
 * Markdown leve para respostas do assistente de suporte (sem dependência extra).
 */
export function renderSupportMarkdown(markdown) {
  const raw = String(markdown ?? '').trim();
  if (!raw) return '';

  const escaped = raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  const lines = escaped.split(/\r?\n/);
  const htmlParts = [];
  let inUl = false;
  let inOl = false;

  const closeLists = () => {
    if (inUl) {
      htmlParts.push('</ul>');
      inUl = false;
    }
    if (inOl) {
      htmlParts.push('</ol>');
      inOl = false;
    }
  };

  const inline = (text) => {
    return text
      .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
      .replace(/`([^`]+)`/g, '<code>$1</code>')
      .replace(
        /\[([^\]]+)\]\((\/ajuda[^)]*|https?:\/\/[^)]+)\)/g,
        '<a href="$2" rel="noopener">$1</a>'
      );
  };

  for (const line of lines) {
    const trimmed = line.trim();
    if (!trimmed) {
      closeLists();
      continue;
    }

    const heading = trimmed.match(/^(#{1,3})\s+(.+)$/);
    if (heading) {
      closeLists();
      const level = heading[1].length;
      htmlParts.push(`<h${level}>${inline(heading[2])}</h${level}>`);
      continue;
    }

    const ul = trimmed.match(/^[-*]\s+(.+)$/);
    if (ul) {
      if (inOl) {
        htmlParts.push('</ol>');
        inOl = false;
      }
      if (!inUl) {
        htmlParts.push('<ul>');
        inUl = true;
      }
      htmlParts.push(`<li>${inline(ul[1])}</li>`);
      continue;
    }

    const ol = trimmed.match(/^\d+\.\s+(.+)$/);
    if (ol) {
      if (inUl) {
        htmlParts.push('</ul>');
        inUl = false;
      }
      if (!inOl) {
        htmlParts.push('<ol>');
        inOl = true;
      }
      htmlParts.push(`<li>${inline(ol[1])}</li>`);
      continue;
    }

    closeLists();
    htmlParts.push(`<p>${inline(trimmed)}</p>`);
  }

  closeLists();

  return sanitizeHtml(htmlParts.join(''), {
    allowedTags: [
      'p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'code', 'a', 'h1', 'h2', 'h3',
    ],
    allowedAttr: ['href', 'rel', 'target', 'class'],
  });
}
